import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import _ from 'lodash';

import { MediaUploadButton, MediaGalleryView } from 'components/MediaLibrary';

import styles from './mediaLibrary.module.scss';

export default function MediaLibrary() {
  const [selected, setSelected] = useState([]);

  const mediaTypes = ['image', 'video']

  const [uploadInstances, setUploadInstances] = useState([]);

  const storyboard = useSelector((state) => _.get(state, "storyboards.storyboard.item", null));

  const handleClick = (media) => {
    setSelected(media);
  }

  return (
    <div className={styles.mediaLibrary}>
      <header className={styles.mediaLibraryHeader}>
        <h1 className={styles.title}>Media Library</h1>
        <MediaUploadButton storyboard={storyboard}
          setUploadInstances={setUploadInstances} />
      </header>
      <MediaGalleryView
        mediaTypes={mediaTypes}
        storyboard={storyboard}
        editable={false}
        onSelect={handleClick}
        selected={selected}
        uploadInstances={uploadInstances}
        setUploadInstances={setUploadInstances}
      />
    </div>
  )
}